import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppRoutes from "./router";

// MUI X pickers imports
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import AppLogout from "./Component/AppLogout";
import ReactCrop from "react-image-crop";
import { AppProvider } from "./Services/AppContext";
import "./consoleLogger";
import RawWebSocket from "./Websocker/RawWebSocket";
import { WEBSOCKET_URL } from "./Services/Constant";
import useStoreKv from "./Screen/redux/store/useStorekv";

function App() {
  const { set } = useStoreKv();
  const dispatch = useDispatch();
  const alertMessage = useSelector((state) => state.alertMessage);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const queryClient = new QueryClient();

  useEffect(() => {
    handleSocket();
  }, [localStorage.getItem("token"), sessionStorage.getItem("token")]);

  const handleSocket = () => {
    let Tok = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (Tok) {
      RawWebSocket.connect(`${WEBSOCKET_URL}?token=${encodeURIComponent(Tok)}`);
      RawWebSocket.clearListeners();
      RawWebSocket.listen("connection_update", (e) => {
        console.log("online count", e);
        set("onlineCount", e?.total_users ?? 0);
        set("totalWallet", e?.total_wallet_amount ?? 0);
        // dispatch(saveOnlineUserCount(e?.total_users ?? 0));
      });
      RawWebSocket.listen("admin_wallet_update", (e) => {
        if (e?.total_amount) set("totalWallet", e?.total_amount);
      });
    } else {
      RawWebSocket.disconnect();
    }
  };

  return (
    <QueryClientProvider client={queryClient}>
      {/* Wrap everything that uses MUI DateTimePickers */}
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <AppProvider>
          <AppLogout>
            <AppRoutes />
            <ScrollToTop />
          </AppLogout>
        </AppProvider>
      </LocalizationProvider>
    </QueryClientProvider>
  );
}

export default App;

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
